/**
 * Copyright © 2026 Delicious AI, LLC
 */

import { gql } from '@apollo/client'

export const FLAG_DETECTION_IMAGE = gql`
  mutation FlagDetectionImage($input: FlagDetectionImageInput!) {
    flagDetectionImage(input: $input) {
      __typename
      ... on FlagDetectionImageResult {
        image {
          id
          isFlagged
          flagged {
            level
            moreInfo
            reasons {
              type
              reason
            }
          }
          leasedById
        }
      }
      ... on OperationInfo {
        messages {
          kind
          message
          field
          code
        }
      }
    }
  }
`
